import { render, staticRenderFns } from "./RefreshMiniIcon.vue?vue&type=template&id=ff8189b6"
import script from "./RefreshMiniIcon.vue?vue&type=script&lang=js"
export * from "./RefreshMiniIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports